import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FacetsPage } from 'src/app/facets/facets-page/facets-page.component';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { UserAuthoritiesService } from 'src/app/services/user-authorities.service';
import { SAAS_ONLY_FEATURE_TOOL_TIP } from 'src/app/constants/tooltips';
import { triggerAnalyticsEvent } from 'src/app/utils/analytics/trigger-analytics';

@Component({
  selector: 'app-rbac-button',
  templateUrl: './rbac-button.component.html',
  styleUrls: ['./rbac-button.component.scss'],
})
export class RBACButtonComponent extends FacetsPage {
  @Input() label: string = '';
  @Input() icon: any;
  @Input() toolTip: string;
  @Input() action: string;
  @Input() iconClass: string = '';
  @Input() status: string = 'control';
  @Input() disabled: boolean = false;
  @Input() size: string = 'small';
  @Input() appearance: string = 'filled';
  @Input() fullWidth: boolean = false;
  @Input() fullHeight: boolean = false;
  @Input() loading: boolean = false;
  @Input() setClass: string = '';
  @Input() showImgFromUrl: boolean = false;
  @Input() imgUrl: string = '';
  @Input() id: string = '';
  @Input() imgClass: string = '';
  @Input() buttonPadding: string = 'p-2';
  @Input() isFciPack: boolean = false;
  @Input() fciIconFontSize: string = '1.1rem';
  @Input() iconStatus: string | undefined;
  @Input() dataAttrActionId: string;
  @Input() disabledForSaaS: boolean = false;
  @Input() inputClusterId: string;
  @Input() actionsList: [] = [];
  @Input() analyticsPrefix: string;

  clusterId: string;
  readonly SAAS_ONLY_FEATURE_TOOL_TIP = SAAS_ONLY_FEATURE_TOOL_TIP;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClick = new EventEmitter<string>();
  constructor(
    private _route: ActivatedRoute,
    public userAuthoritiesService: UserAuthoritiesService,
    public featureFlagService: FeatureFlagsService,
  ) {
    super(_route);
  }

  emitOnClickEvent() {
    if (this.id?.length > 0) {
      if (this.analyticsPrefix) {
        triggerAnalyticsEvent(`${this.analyticsPrefix}`);
      }
      this.onClick.emit(this.id);
    } else {
      this.onClick.emit();
    }
  }

  OnPageLoad(p: Params): void {
    if (p) {
      this.clusterId = p?.clusterId;
    }
    if (!p?.clusterId && this.inputClusterId) {
      this.clusterId = this.inputClusterId;
    }
  }
}
